import { render } from "./Statistiche.vue?vue&type=template&id=b71dea3c&scoped=true"
import script from "./Statistiche.vue?vue&type=script&lang=js"
export * from "./Statistiche.vue?vue&type=script&lang=js"

import "./Statistiche.vue?vue&type=style&index=0&id=b71dea3c&scoped=true&lang=css"

import exportComponent from "/root/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b71dea3c"]])

export default __exports__